import Vue from "vue"
import Router from "vue-router"
import home from "@/view/index"
import newslist from "@/view/newslist"
import about from "@/view/about"
import contact from "@/view/contact"
import product from "@/view/product"
import prodetails from "@/view/prodetails"
import curriculum from "@/view/curriculum"
import details from "@/view/details"
import noLogin from "@/view/noLogin"
import Login from "@/view/Login"
Vue.use(Router)

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "home",
      component: home,
      meta: {
        title: "内蒙古医学电子报告"
      }
    },
    {
      path: "/newslist",
      name: "newslist",
      component: newslist,
      meta: {
        title: "新闻中心"
      },
      component: () => import("@/view/newslist.vue")
    },
    {
      path: "/about",
      name: "about",
      component: about,
      meta: {
        title: "关于我们"
      },
      component: () => import("@/view/about.vue")
    },
    {
      path: "/contact",
      name: "contact",
      component: contact,
      meta: {
        title: "留言板"
      },
      component: () => import("@/view/contact.vue")
    },
    {
      path: "/product",
      name: "product",
      component: product,
      meta: {
        title: "招生就业"
      },
      component: () => import("@/view/product.vue")
    },
    {
      path: "/prodetails",
      name: "prodetails",
      component: prodetails,
      meta: {
        title: "招聘详情"
      },
      component: () => import("@/view/prodetails.vue")
    },
    {
      path: "/curriculum",
      name: "curriculum",
      component: curriculum,
      meta: {
        title: "实验中心"
      },
      component: () => import("@/view/curriculum.vue")
    },
    {
      path: "/details",
      name: "details",
      component: details,
      meta: {
        title: "新闻详情"
      },
      component: () => import("@/view/details.vue")
    },
    {
      path: "/noLogin",
      name: "noLogin",
      component: noLogin,
      meta: {
        title: "新闻详情"
      },
      component: () => import("@/view/noLogin.vue")
    },
    {
      path: "/Login",
      name: "Login",
      component: Login,
      meta: {
        title: "登录"
      },
      component: () => import("@/view/Login.vue")
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js